import _ from 'lodash';
import uri from 'urijs';
import createAction from '../services/create-action';
import { buildPaginationRequestParams } from '../services/pagination';

export const FETCH_FOLLOWERS_REQUEST = 'followers/FETCH_REQUEST';
export const FETCH_FOLLOWERS_SUCCESS = 'followers/FETCH_SUCCESS';
export const FETCH_FOLLOWERS_FAILURE = 'followers/FETCH_FAILURE';

export const fetchFollowersRequest = createAction(FETCH_FOLLOWERS_REQUEST);
export const fetchFollowersSuccess = createAction(FETCH_FOLLOWERS_SUCCESS, _.identity, (payload, meta) => meta);
export const fetchFollowersFailure = createAction(FETCH_FOLLOWERS_FAILURE);

export function fetchFollowers({ userId, page, pageSize }) {
  return (dispatch, getState, { request }) => {
    dispatch(fetchFollowersRequest());

    const query = buildPaginationRequestParams(page, pageSize);
    const promise = request(uri(`/_api/users/${userId}/followers`).query(query), { parseHeaders: true });
    return promise
      .then(({ body = [], headers = {} }) => {
        const payload = { followers: body };
        const meta = { count: parseInt(headers.get('Wix-Forum-TotalResults'), 10) };
        return dispatch(fetchFollowersSuccess(payload, meta));
      })
      .catch(() => dispatch(fetchFollowersFailure()))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/fetch-followers.js